module.exports = __webpack_public_path__ + "static/media/icon-home-tag4.c36c6497.png";